"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.totalsAbi = void 0;
exports.totalsAbi = [
    {
        inputs: [
            {
                internalType: 'contract IERC20',
                name: '',
                type: 'address',
            },
        ],
        name: 'totals',
        outputs: [
            {
                internalType: 'uint128',
                name: 'elastic',
                type: 'uint128',
            },
            {
                internalType: 'uint128',
                name: 'base',
                type: 'uint128',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
];
//# sourceMappingURL=totalsAbi.js.map